module.exports = __webpack_public_path__ + "static/media/galaxy-4.bfbf4e1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galaxy-4.svg
// module id = 488
// module chunks = 0